import React, { Component } from 'react';
// import { Link } from 'react-router-dom';

// import recent1 from '../../assets/img/sidebar/recent-01.jpg';
// import recent2 from '../../assets/img/sidebar/recent-02.jpg';
// import recent3 from '../../assets/img/sidebar/recent-03.jpg';

import authorimg from '../../assets/img/sidebar/author.jpg';

// import cta from '../../assets/img/sidebar/cta.jpg';

// const categories = [
//     { title: 'Financial Planning' },
//     { title: 'Relationship Building' },
//     { title: 'Investment Planning' },
//     { title: 'Wisdom' },
//     { title: 'Ministry' },
// ]

// const recentpost = [
//     { img: recent1, title: 'Smashing Podcast J.W. Oliver Jr', postdate: '25 Aug 2022' },
//     { img: recent2, title: 'Responsive Web And Desktop Develop', postdate: '25 Aug 2022' },
//     { img: recent3, title: 'Django Highlig Models Admin Harnessing', postdate: '25 Aug 2022' },
// ]

// const tags = [
//     { tag: 'Business' },
//     { tag: 'Corporate' },
//     { tag: 'HTML' },
//     { tag: 'Finance' },
//     { tag: 'Investment' },
//     { tag: 'Ministry' },
//     { tag: 'Planing' },
//     { tag: 'Creative' },
// ]

class Blogsidebar extends Component {
    render() {
        return (
            <div className="sidebar">
                {/* Search Widget */}
                {/* <div className="widget search-widget">
                <form action="#">
                    <input type="text" placeholder="Search here" />
                    <button type="submit"><i className="far fa-search" /></button>
                </form>
            </div> */}

                {/* Author Infor Widget */}
                <div className="widget author-widget">
                    <img src={authorimg} alt="" className="author-img" />
                    <h4 className="name">J.W. Oliver Jr</h4>
                    <span className="role">Author</span>
                    <p>
                        He loves to see others laugh and desires most of all to encourage others and show them Jesus.
                    </p>
                    <ul className="social-icons">
                        <li><a href="https://www.facebook.com/jw.oliver.12" target='_blank' rel="noopener noreferrer"><i className="fab fa-facebook-f" /></a></li>
                        {/* <li><a href="#" target='_blank' rel="noopener noreferrer"><i className="fab fa-twitter"/></a></li> */}
                        <li><a href="https://www.instagram.com/jwoliverjr/" target='_blank' rel="noopener noreferrer" ><i className="fab fa-instagram" /></a></li>
                        <li><a href="https://www.linkedin.com/in/j-w-oliver-jr-28023213" target='_blank' rel="noopener noreferrer"><i className="fab fa-linkedin" /></a></li>
                        {/* <li><a href="https://www.youtube.com/channel/UCKtaHivvgwnjauwkH1YgHyQ" target='_blank' rel="noopener noreferrer"><i className="fab fa-youtube" /></a></li> */}
                    </ul>
                </div>


                {/* Cat Widget */}
                {/* <div className="widget cat-widget">
                    <h4 className="widget-title">Category</h4>
                    <ul>
                        {categories.map((item, i) => (
                            <li key={i}>
                                <Link to="/blog">{item.title} <span><i className="far fa-angle-right" /></span></Link>
                            </li>
                        ))}
                    </ul>
                </div> */}
                {/* Recent Post Widget */}
                {/* <div className="widget recent-post-widget">
                <h4 className="widget-title">Recent News</h4>
                <div className="post-loops">
                    {recentpost.map((item, i) => (
                        <div key={i} className="single-post">
                            <div className="post-thumb">
                                <img src={item.img} alt="" />
                            </div>
                            <div className="post-desc">
                                <span className="date"><i className="far fa-calendar-alt" />{item.postdate}</span>
                                <Link to="/blog">{item.title}</Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div> */}
                {/* Popular Tag Widget */}
                {/* <div className="widget popular-tag-widget">
                <h4 className="widget-title">Popular Tags</h4>
                <div className="tags-loop">
                    {tags.map((item, i) => (
                        <Link key={i} to="/blog">{item.tag}</Link>
                    ))}
                </div>
            </div> */}

                {/* CTA Widget */}
                {/* <div className="widget cta-widget" style={{ backgroundImage: "url(" + cta + ")" }}>
                    <h4 className="title">Need Any Consultations</h4>
                    <Link to="/contact" className="main-btn">Send Message</Link>
                </div> */}
            </div>
        );
    }
}

export default Blogsidebar;